// src/mocks/demoData.ts
// Typed access to the shared demo data (simbDemoData.json): seeds the demo store and the Stats mocks.
import raw from "./simbDemoData.json";
import type { Asset, UploadAttemptLog } from "../modules/assetManagement/types";

export interface DemoEvent {
  id: string;
  title: string;
  description: string;
  notes: string;
  startDate: string;
  endDate: string | null;
  status: "Active" | "Scheduled" | "Archived";
  tags: string[];
  productIds: string[];
}

export interface DemoProduct {
  id: string;
  title: string;
  description: string;
  notes: string;
  launchDate: string;
  endDate: string | null;
  status: "Active" | "Archived";
  tags: string[];
}

export interface DemoAlert {
  id: string;
  level: "warning" | "info";
  icon: "assets" | "billing";
  message: string;
}

export interface DemoData {
  events: DemoEvent[];
  products: DemoProduct[];
  assets: Asset[];
  uploadLog: UploadAttemptLog[];
  stats: {
    storage: { usedGb: number; limitGb: number; currentTier: string; nextTier: string };
    alerts: DemoAlert[];
  };
}

export const demoData = raw as unknown as DemoData;
